import React, { Component } from 'react';
import TableRow from "@material-ui/core/TableRow";

class RegisterTableItem extends Component {

    getValue = (value, tag) => {
        if(tag !== undefined && tag !== null && tag.includes('-date')){
          var options = { day:'2-digit', month: 'short', year:'2-digit', hour:  "2-digit",
          minute: "2-digit",
          second: "2-digit"};
          var options2 = { day:'2-digit', month: 'short', year:'2-digit'};
          const date =  new Date(value);
          const lastWord = tag.substr(tag.length-4);
          return ( lastWord !== 'date') ? date.toLocaleString('en-GB', options) : date.toLocaleDateString('en-GB', options2);
        }else{
          return value;
        }
      }

    render() {
        return (
            <TableRow 
                style= {
                    {
                        fontSize: '1.3rem'
                    }
                }
                key={this.props.register.id}>
                    <td>{this.props.register.tag}</td>
                    <td style={{textAlign: 'center'}}>{this.getValue(this.props.register.value,this.props.register.tag)}</td>
                    <td style={{textAlign: 'center'}} >{new Date(this.props.register.created).toLocaleString('en-GB', { timeZone: 'UTC' })}</td>
            </TableRow>
        );
    }
}

export default RegisterTableItem;


// WEBPACK FOOTER //
// ./src/components/RegisterTableItem.js